import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const addCriticalCSS = () => {
  const style = document.createElement('style');
  style.innerHTML = `
    /* Critical CSS for initial render */
    body, html { margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
    .w-full { width: 100%; }
    .h-64 { height: 16rem; }
    .h-20 { height: 5rem; }
    .bg-gray-100 { background-color: #f3f4f6; }
    .flex { display: flex; }
    .items-center { align-items: center; }
    .justify-center { justify-content: center; }
    .animate-pulse { animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
    .animate-spin { animation: spin 1s linear infinite; }
    .border-blue-500 { border-color: #3b82f6; }
    .rounded-full { border-radius: 9999px; }
    .border-t-2, .border-b-2 { border-width: 2px; border-style: solid; }
    @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: .5; } }
    @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
  `;
  document.head.appendChild(style);
};
addCriticalCSS();
// Get the root element
const root = document.getElementById('root');
// Use simple direct rendering instead of requestIdleCallback
if (root) {
  render(<App data-id="element-411" />, root);
}
// Report web vitals after page load
if ('performance' in window && 'getEntriesByType' in performance) {
  window.addEventListener('load', () => {
    const paintMetrics = performance.getEntriesByType('paint');
    paintMetrics.forEach(metric => {
      console.log(metric);
    });
  });
}